import { operatorClient } from 'domain/HttpClients';

export const getShippers = async (key) => {
  try {
    const response = await operatorClient
      .Get('api/shippers')
      .withParams({ did: SYSTEM_DOMAIN, status: 'ACTIVE', firstName: key })
      .send();
    const output = response.results.map((shipper) => ({
      value: shipper.id,
      label: shipper.name,
    }));
    return output;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const getPickupCities = async (key) => {
  try {
    const response = await operatorClient
      .Get('api/shipments/pickup-cities')
      .withParams({ prefix: key })
      .send();
    const output = response.map((row) => ({
      value: row,
      label: row,
    }));
    return output;
  } catch (e) {
    console.error(e);
    return [];
  }
};
export const getDropoffCities = async (key) => {
  try {
    const response = await operatorClient
      .Post('api/shipments/dropoff-cities')
      .withParams({ prefix: key })
      .send();
    const output = response.map((row) => ({
      value: row,
      label: row,
    }));
    return output;
  } catch (e) {
    console.error(e);
    return [];
  }
};
